<template>
  <div>
    <p class="has-text-weight-semibold is-size-5">{{ title }}</p>
    <p class="vendor has-text-weight-light is-size-6">{{ vendor }}</p>
    <p class="description" :key="index" v-for="(message, index) in messages">
      {{ message }}
    </p>
  </div>
</template>

<script>
export default { name: "Description", props: ["title", "vendor", "messages"] };
</script>

<style>
.description {
  text-align: justify;
  margin-bottom: 0.75rem;
}
.vendor {
  margin-bottom: 1.5rem;
}
</style>
